import { Component } from "react";
import FlexView from "react-flexview";
import CardBiaxialChart from "../../../../../../cards/BiaxialChart";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import {
  getConfigLast3Years,
  getConfigLast3YearsSA,
  transformResponseLastThreeYearsToTable,
  transformResponseLastThreeYearsToTableSA,
  yearOptions,
} from "../config";
import { service } from "../service";
import React from "react";
import { saveAs } from "file-saver";
import { buildExcelRequestBodyJualPartL3Y } from "../configExcel";

const RoleLegend = () => (
  <FlexView style={{ gap: 20, marginBottom: 10 }}>
    <FlexView style={{ alignItems: "center", gap: 8 }}>
      <span
        style={{
          width: 12,
          height: 12,
          backgroundColor: "#E53935",
          display: "inline-block",
        }}
      />
      <span>Mechanic</span>
    </FlexView>

    <FlexView style={{ alignItems: "center", gap: 8 }}>
      <span
        style={{
          width: 12,
          height: 12,
          backgroundColor: "#43A047",
          display: "inline-block",
        }}
      />
      <span>Service Advisor</span>
    </FlexView>
  </FlexView>
);
class LaporanPartL3Y extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: getConfigLast3Years("MECHANIC"),
      tableConfigSA: getConfigLast3YearsSA("SA"),
      dataTable: [],
      dataTableSA: [],
      chartVisible: false,
      chartLast3Years: null,
      rawData: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState({
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    });
  }

  compareObject = (data1, data2) => {
    return JSON.stringify(data1) === JSON.stringify(data2);
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhirH23,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kabeng Keatas - Laporan Jualan 3 Tahun Terakhir",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          year: this.state.year.value,
          employeeId: null,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const rawData = res.data.data || [];

        const mechanicData = rawData.filter(
          (item) => item.employeeRole === "MECHANIC",
        );
        const saData = rawData.filter((item) => item.employeeRole === "SA");

        this.setState({
          rawData,
          dataTable: transformResponseLastThreeYearsToTable(mechanicData),
          dataTableSA: transformResponseLastThreeYearsToTableSA(saData),
          tableConfig: getConfigLast3Years("MECHANIC"),
          tableConfigSA: getConfigLast3YearsSA("SA"),
        });
      }

      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("errors: ", error);
    }
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  handlePrint = async () => {
    const { month, year, dataTable, dataTableSA } = this.state;

    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartL3Y({
        year,
        dataTable,
        dataTableSA,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Jual Part L3Y",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    const { rawData, chartVisible } = this.state;
    const { data, dataKey } = service.transformChartData(rawData);

    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <>
            <div style={{ marginBottom: 30 }}>
              <SimpleDataTable
                data={this.state.dataTable}
                columns={this.state.tableConfig}
                options={{ pagination: false }}
              />
            </div>

            <SimpleDataTable
              data={this.state.dataTableSA}
              columns={this.state.tableConfigSA}
              options={{ pagination: false }}
            />
          </>
        )}

        {this.state.chartVisible && (
          <>
            <RoleLegend />

            <CardBiaxialChart data={data} dataKey={dataKey} />
          </>
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton
            id="btn_print"
            text="CETAK"
            style={{ marginRight: 5 }}
            onClick={() => this.handlePrint()}
          />
          <SimpleButton onClick={this.handleChartVisibility}>
            CHART
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default LaporanPartL3Y;
